let _store: any = null;

export function setStore(store: any): void {
  _store = store;
}

export function getStore(): any {
  return _store;
}
